<template>
  <div class="hello">
    <div class="topOperation">
      <div>
        <div><ShowNavHead/></div>
      </div>
      <div class="top-right">
        <button class="search" @click="dialogVisible = true" v-if="this.errorLength<10">校验入库</button>
        <!-- <button class="exportButton">导出</button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item >客户</el-breadcrumb-item>
          <el-breadcrumb-item >项目</el-breadcrumb-item>
          <el-breadcrumb-item >存档花名册</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/employee-operationRecord'}">导入导出记录</el-breadcrumb-item>
          <el-breadcrumb-item >导入详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable2">
        <!--  @cell-dblclick="showEditInput" -->
        <el-table :data="tableData" :max-height="tableHeight-180"  border style="width: 99%" v-loading="listLoading" :lazy="true">
          <!-- <el-table-column align="center" fixed label="排序" width="50">
            <template slot-scope="{$index}">
              <span>{{(Number(currpage) - 1) * Number(pageSize) + Number($index) + 1}}</span>
            </template>
          </el-table-column> -->
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :key="index" :width="item.StrColumName=='户籍地址'|| item.StrColumName=='现住地址' || item.StrColumName=='参保日期' || item.StrColumName=='签订合同起止时间记录' || item.StrColumName=='备注' ? 380 : (item.StrColumName=='发薪公司全称' ? 280 : 180) " align="center"
              :fixed="item.StrColumName=='序号' || item.StrColumName=='档案号' || item.StrColumName=='姓名'" v-if="item.StrColumName!='序号'">
              <template slot-scope="scope">
                
                <div v-if="item.StrColumName=='身份证有效终止时间'||item.StrColumName=='用工之日'||item.StrColumName=='试用期到期日期'||item.StrColumName=='劳动合同起始时间'||item.StrColumName=='劳动合同到期时间'||item.StrColumName=='离职日期'||item.StrColumName=='实际离职日期'||item.StrColumName=='工伤发生时间'||item.StrColumName=='工伤纠纷结束时间'">
                  {{ isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId]}}</div>
                <div v-else>{{scope.row[item.StrColumId]}}</div>
              </template>
            </el-table-column>
          </template>
        </el-table>

        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage3"
            :page-size="pagecount"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,prev,sizes,pager, next, jumper"
            :total="this.totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="dialog">
      <!-- 校验入库 -->
      <el-dialog :visible.sync="dialogVisible" width="480px">
        <div class="delTitle">校验入库</div>
        <div style="padding:20px 20px 20px 0">请确认是否已经修改格式错误的数据，格式错误的数据入库后将是空值</div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button
            class="search"
            @click="checkInventory()"
            style="margin-left:10px;font-weight:600"
          >确定入库</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import xz from "../../common";

export default {
  
  name: "HelloWorld",
  data() {
    return {
       tableHeight:0,
      style1:{
        color:'rgb(255, 67, 98)'
      },
      pagecount:10,
      listLoading:false,
      dialogVisible:false,
      errorLength:"",
      path:"",
      currentPage3: 1,
      tableData:[],
      totalcount:null,
      currpage:1,
      bank: this.$store.state.EMP.bank,
      CityzenType: this.$store.state.EMP.CityzenType,
      //分公司
      SrvCent: this.$store.state.EMP.SrvCent,
      //合同类型
      ContractType: this.$store.state.EMP.ContractType,
      // InsuranceType: this.$store.state.EMP.InsuranceType,
      //学历水平
      eduLv:this.$store.state.EMP.eduLv,
      //民族
      nationals:this.$store.state.EMP.nationals,
      //表头内容
      tableTitle:[]
    };
  },
  computed:{
  },
  created(){
    this.calHeight();
    let q =  this.$route.query;
    this.path = q.path;
    this.errorLength = q.errorLength;
    this.getImprtInfo();
    //自定义字段
    this.getCustomList()
  },
  mounted(){
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
      console.log('height',this.tableHeight) 
    },
    handleCurrentChange(val) {
     this.currpage = `${val}`;
     this.getImprtInfo();
    },
    handleSizeChange(val) {
        this.pagecount = parseInt(val);
        this.getImprtInfo();
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    //自定义拓展字段
    getCustomList(){
      const data = {
        pagecount: 100000,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed:'all'  //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
      };
      xz.getImportFiledInfo(data).then(res =>{
        // console.log('自定义拓展字段',res)
        if (res && res.data.length > 0) {
          try {
            res.data.forEach(element => {
              if (element.StrColumName == '身份证号码') {
                let a1 = {
                  StrColumId: 'idcardJudge',
                  StrColumName: '判定'
                };
                let a2 = {
                  StrColumId: 'sex',
                  StrColumName: '性别'
                };
                let a3 = {
                  StrColumId: 'birth',
                  StrColumName: '出生年月'
                };
                let a4 = {
                  StrColumId: 'age',
                  StrColumName: '年龄'
                };
                res.data.splice(element.IntOrderId + 1, 0, a1, a2, a3, a4);
                this.tableTitle = res.data;
                throw new Error('ending')
              }
            });
          } catch (e) {
            if (e.message != "ending") throw e;
          }
          this.tableTitle = res.data;
        } else {
          this.tableTitle = []
        }
      })
    },
    //获取花名册信息
    getImprtInfo(){
      // console.log('pathInfo',this.path)
      this.listLoading = true
       const qdata ={
              excelpath:this.path,
              pagecount:this.pagecount,
              currpage:this.currpage
            }
            xz.getHistoryInfo(qdata).then(res=>{
              console.log('res',res,qdata)
              let i = 1 + (this.currpage-1)*10;
              let rightData = []
              if(res.data.length>0){
                 res.data.forEach(l => {
                   l.DtEntryBdate ? (l.DtEntryBdate = l.DtEntryBdate.substring(0,10)) : '-';
                   l.DtProbationEdate ? (l.DtProbationEdate = l.DtProbationEdate.substring(0,10)) : '-';
                   l.DtContractBtime ? (l.DtContractBtime = l.DtContractBtime.substring(0,10)) : '-';
                   l.DtContractTime ? (l.DtContractTime = l.DtContractTime.substring(0,10)) : '-';
                   l.DtDepartureDate ? (l.DtDepartureDate = l.DtDepartureDate.substring(0,10)) : '-';
                   l.DtRealDepartureDate ? (l.DtRealDepartureDate = l.DtRealDepartureDate.substring(0,10)) : '-';
                   l.DtInjuryBdate ? (l.DtInjuryBdate = l.DtInjuryBdate.substring(0,10)) : '-';
                   l.DtInjuryEdate ? (l.DtInjuryBdate = l.DtInjuryEdate.substring(0,10)) : '-';
                   l.DtInsuranceDate ? (l.DtInsuranceDate = l.DtInsuranceDate) : '-';
                   l.DtInjuryEdate ? (l.DtInjuryEdate = l.DtInjuryEdate.substring(0,10)) : '-';
                   l['num'] = i++;
                   //去除返回格式有错误的数据
                   if(!l.innerOtherinf){
                     rightData.push(l)
                   }
                });
                // console.log('rightData',rightData)
                this.tableData = rightData;
                this.totalcount= parseInt(res.totalcount);
                this.getPsInfo()
              }
              else{
                this.tableData = []
                this.totalcount = 0
              }
              this.listLoading = false
            })
    },
     getPsInfo(){
      this.tableData.forEach(l => {
       let idcode = l.StrIdCard;
        // 加权因子
      var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验码
      var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      var code = idcode + "";
      var last = idcode[17]; //最后一个
      var seventeen = code.substring(0, 17);
      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
      }
      // 获取余数
      var resisue = num % 11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
	    第一位不可能是0
	    第二位到第六位可以是0-9
	    第七位到第十位是年份，所以七八位为19或者20
	    十一位和十二位是月份，这两位是01-12之间的数值
	    十三位和十四位是日期，是从01-31之间的数值
	    十五，十六，十七都是数字0-9
	    十八位可能是数字0-9，也可能是X
	    */
      var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
      // 判断格式是否正确
      var format = idcard_patter.test(idcode);
      var idcardJudge = null;
      if(last === last_no && format==true){
        idcardJudge="true"
      }else{
        idcardJudge="false"
      }
     
      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码

      //获取出生年月、性别、年龄
       let myDate = new Date();
       let month = myDate.getMonth() + 1;
       let day = myDate.getDate();
       let iden = idcode;
       let sexnum =null;
       let sex = null;
       let birth = null;
       let age = 0;
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        sexnum = iden.substring(16,17);
        if(sexnum%2 ===0){
          sex = '女'
        }else{
          sex = '男'
        }
        birth = iden.substring(6,10)+"/"+iden.substring(10,12)+"/"+iden.substring(12,14);
        if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;
        l['birth'] =birth;
        l['sex'] =sex;
        l['age'] =age;
        l['idcardJudge'] =idcardJudge;
      });
    },
    //校验入库
    checkInventory(){
      const  tableid="XZ_emp_UserBase";
      xz.checkInv(tableid,this.path).then(res=>{
        if(res){
          this.$message({
            message: "校验入库可能需要一段时间，请稍等",
            type: "success"
          });
        } else {
          this.$message.error("校验入库失败！");
        }
      })
      this.dialogVisible = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
:focus {
  outline: 0;
}
</style>


<style >
.customerRosterTable2 .el-table td {
  padding: 8px 0 ;
}
.customerRosterTable2 .el-table th {
  padding:12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 56px;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card>.el-tabs__content{
    max-height: 200px;
    overflow-y: scroll;
}
.dialog .el-card__body{
  max-height: 208px;
    overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
    margin-left: 10px;
  }
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner{
  border-color:#19BD92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #19BD92;
    border-color: #19BD92;
}
.tagArea .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #19BD92;
}
.tagArea .el-checkbox__inner:hover{
  border-color: #19BD92;
}
.tagArea .el-tag--plain.el-tag--success{
  color:#19BD92;
}
.tagArea .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
  color: #19BD92;
}
.tagArea .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
  color: #19BD92;
}
</style>